import { areaFillColor, areaStrokeColor } from './Estimates.styles.css';

export const previewGraphTheme = (obscure?: boolean) => {
    return {
        chart: {
            // Prevents area stroke being cut off when it's at top of graph
            domainPadding: { y: 2 },
            // Accounts for 3 digit price labels and 1 line month labels
            padding: { top: 5, bottom: 20, right: 0, left: 50 },
        },
        axis: {
            style: {
                axis: { strokeWidth: 0 },
                grid: {
                    stroke: 'none',
                },
                tickLabels: {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    filter: (a: any) =>
                        a?.scale?.y && obscure ? 'blur(3px)' : 'unset',
                    padding: 6,
                    fontSize: 12,
                    fontFamily: 'inherit',
                },
            },
        },
        area: {
            style: {
                data: {
                    fill: areaFillColor,
                    stroke: areaStrokeColor,
                    strokeWidth: 2,
                },
            },
        },
    };
};
